<template>
    <div class="mb-[21px] grid grid-cols-1 gap-6 md:grid-cols-4">
        <div
            class="rounded-[12.8px] border border-gray-200 bg-white p-6 transition-all duration-200"
        >
            <div class="mb-4 flex items-start justify-between">
                <DonutChartLight :data="donutData" />
            </div>
            <div>
                <p class="mb-1 text-sm text-gray-600" style="color: #4b5563">
                    {{ $t("vue.dmarc_compliance") }}
                </p>
                <p
                    v-if="props.statistics.complianceRate > 0"
                    class="text-2xl font-semibold text-gray-900"
                >
                    {{ Math.trunc(props.statistics.complianceRate) }}%
                </p>
                <p v-else class="text-2xl font-semibold text-gray-900">-</p>
            </div>
        </div>

        <div
            class="rounded-[12.8px] border border-gray-200 bg-white p-6 transition-all duration-200"
        >
            <div class="mb-4 flex items-start justify-between">
                <div
                    class="flex h-12 w-12 items-center justify-center rounded-[12.8px] bg-blue-500"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-mail h-6 w-6 text-white"
                        aria-hidden="true"
                    >
                        <path
                            d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"
                        ></path>
                        <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                    </svg>
                </div>
                <DeltaIndicator
                    v-if="
                        statsBefore && statsBefore.pass + statsBefore.fail > 0
                    "
                    :before="statsBefore.pass + statsBefore.fail"
                    :now="stats.pass + stats.fail"
                    :informative="true"
                />
            </div>
            <div>
                <p class="mb-1 text-sm text-gray-600">
                    {{ $t("vue.total_emails_reported") }}
                </p>
                <div
                    v-if="totalEmailsReported > 0"
                    class="flex items-baseline gap-2"
                >
                    <!--                    <p-->
                    <!--                        v-if="-->
                    <!--                            page.props.hasFreePlan &&-->
                    <!--                            totalEmailsReported >= 5000-->
                    <!--                        "-->
                    <!--                        class="text-2xl font-semibold text-gray-900"-->
                    <!--                    >-->
                    <!--                        5000-->
                    <!--                    </p>-->
                    <!--                    <p v-else class="text-2xl font-semibold text-gray-900">-->
                    <!--                        {{ formattedTotalEmailsReported }}-->
                    <!--                    </p>-->
                    <p class="text-2xl font-semibold text-gray-900">
                        {{ formattedTotalEmailsReported }}
                    </p>
                    <!--                    <p-->
                    <!--                        v-if="page.props.hasFreePlan"-->
                    <!--                        class="text-xs font-medium leading-5 text-gray-700"-->
                    <!--                    >-->
                    <!--                        {{ $t("vue.showing_of") }} {{ formattedFreePlanLimit }}-->
                    <!--                    </p>-->
                </div>
                <p v-else class="text-2xl font-semibold text-gray-900">-</p>
            </div>
        </div>

        <div
            class="rounded-[12.8px] border border-gray-200 bg-white p-6 transition-all duration-200"
        >
            <div class="mb-4 flex items-start justify-between">
                <div
                    class="flex h-12 w-12 items-center justify-center rounded-[12.8px] bg-green-500"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-shield h-6 w-6 text-white"
                        aria-hidden="true"
                    >
                        <path
                            d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                        ></path>
                    </svg>
                </div>
                <DeltaIndicator
                    v-if="statsBefore && statsBefore.pass"
                    :before="statsBefore.pass"
                    :now="stats.pass"
                />
            </div>
            <div>
                <p class="mb-1 text-sm text-gray-600">
                    {{ $t("vue.dmarc_compliant") }}
                </p>
                <p
                    v-if="props.statistics.dmarcCompliant > 0"
                    class="text-2xl font-semibold text-gray-900"
                >
                    {{
                        new Intl.NumberFormat().format(
                            props.statistics.dmarcCompliant,
                        )
                    }}
                </p>
                <p v-else class="text-2xl font-semibold text-gray-900">-</p>
            </div>
        </div>

        <div
            class="rounded-[12.8px] border border-gray-200 bg-white p-6 transition-all duration-200"
        >
            <div class="mb-4 flex items-start justify-between">
                <div
                    class="flex h-12 w-12 items-center justify-center rounded-[12.8px] bg-red-500"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-shield-alert h-6 w-6 text-white"
                        aria-hidden="true"
                    >
                        <path
                            d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                        ></path>
                        <path d="M12 8v4"></path>
                        <path d="M12 16h.01"></path>
                    </svg>
                </div>
                <DeltaIndicator
                    v-if="statsBefore && statsBefore.fail"
                    :before="statsBefore.fail"
                    :now="stats.fail"
                    :inverted="true"
                />
            </div>
            <div>
                <p class="mb-1 text-sm text-gray-600">
                    {{ $t("vue.dmarc_non_compliant") }}
                </p>
                <p
                    v-if="props.statistics.dmarcNonCompliant > 0"
                    class="text-2xl font-semibold text-gray-900"
                >
                    {{
                        new Intl.NumberFormat().format(
                            props.statistics.dmarcNonCompliant,
                        )
                    }}
                </p>
                <p v-else class="text-2xl font-semibold text-gray-900">-</p>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, defineProps } from "vue";
import DonutChartLight from "@/Pages/Reports/components/DonutChart/DonutChartLight.vue";
import { usePage } from "@inertiajs/vue3";
import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps.ts";

const page = usePage<IRhizomPageProps>();

const props = defineProps<{
    stats: {
        pass: number;
        fail: number;
    };
    statsBefore: {
        pass: number;
        fail: number;
    } | null;
    statistics: {
        totalEmailsReported: number;
        dmarcCompliant: number;
        dmarcNonCompliant: number;
        complianceRate: number;
    };
}>();

const donutData = computed(() => {
    const total =
        props.statistics.dmarcCompliant + props.statistics.dmarcNonCompliant;

    if (total === 0) {
        return [{ key: "no-data", value: 1 }];
    }

    const rate = Math.trunc(props.statistics.complianceRate);
    return [
        { key: "compliant", value: rate },
        { key: "non-compliant", value: 100 - rate },
    ];
});

const totalEmailsReported = computed(() => {
    return props.statistics.dmarcCompliant + props.statistics.dmarcNonCompliant;
});

const formattedTotalEmailsReported = computed(() => {
    return new Intl.NumberFormat().format(totalEmailsReported.value);
});

const formattedFreePlanLimit = computed(() => {
    return new Intl.NumberFormat().format(5000);
});
</script>
